import React, { useEffect } from 'react'
import reactimg from './images/react.avif';
import nodeimg from './images/node.avif'
import awsimg from './images/aws.avif'
import { Link } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeWellLikedCourse = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='Home_well_likedcourse_section'>
            <div className='container-fluid'>

                <div className='Home_well_likedcourse_section_head' data-aos="zoom-in" data-aos-duration="2000">
                    <h1>Well-liked Courses</h1>
                    <p>At Hamo Tech, we offer a diverse range of courses designed to meet the needs of aspiring tech professionals. Our well-liked courses are highly recommended by students and industry experts alike for their comprehensive curriculum, practical approach, and career-boosting potential. Here are some of the most popular courses that students are raving about</p>
                </div>
                <div className='row'>
                    <div className='col-md-4 mt-3' data-aos="fade-up" data-aos-duration="1000">
                        <div className="card">
                            <div className='Home_well_likedcourse_section_img'>
                                <img src={reactimg} className='img-fluid' alt='' />
                            </div>
                            {/* <div className='Home_well_likedcourse_section_cost'>
                                <p>Course Fee : ₹{1000} (USD $
                                    {(1000 * (1/80)).toFixed(2)})</p>
                            </div> */}
                            <hr />
                            <div className='Home_well_likedcourse_section_content'>

                                <div className='d-flex'>
                                    <div className=' Home_well_likedcourse_section_content2'>
                                        <img src='https://img.freepik.com/free-vector/smiling-redhaired-boy-illustration_1308-176664.jpg?t=st=1734542503~exp=1734546103~hmac=37244d31ed2c5273dc7b1de693199b415c45120e94c814fbe43f57d5dd09bb8a&w=740' alt='' className='img-fluid' />
                                    </div>
                                    <div className=' Home_well_likedcourse_section_content1'>
                                        <a href='#'>KUMAR</a>

                                        <div className='Home_well_likedcourse_section_review'>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-half-line"></i>
                                            <span>4.5 (2,760)</span>
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <h3>React Development</h3>
                                    <p className='text-justify'>React Development is a powerful JavaScript library for building dynamic and efficient user interfaces. It uses a component-based architecture and a virtual DOM, enabling fast rendering and seamless user experiences.</p>
                                </div>
                                <hr />
                                <div className='Home_well_likedcourse_section_time'>
                                    <div className='Home_well_likedcourse_section_pp'>
                                        <p> <i class="ri-user-line"></i> 6,645</p>
                                        {/* <p><i class="ri-time-line"></i> 16 : 00</p> */}
                                    </div>

                                    <div className='Home_well_likedcourse_section_time_btn'>
                                        <Link to="/contact-us"> <button>Enroll Now</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4 mt-3' data-aos="fade-up" data-aos-duration="1500">
                        <div className="card">
                            <div className='Home_well_likedcourse_section_img'>
                                <img src={nodeimg} className='img-fluid' alt='' />
                            </div>
                            {/* <div className='Home_well_likedcourse_section_cost'>
                                <p>Course Fee : ₹{1200} (USD $
                                    {(1200 * (1 / 80)).toFixed(2)})</p>
                            </div> */}
                            <hr />
                            <div className='Home_well_likedcourse_section_content'>

                                <div className='d-flex'>
                                    <div className=' Home_well_likedcourse_section_content2'>
                                        <img src='https://img.freepik.com/free-vector/smiling-young-man-glasses_1308-174373.jpg?t=st=1733138704~exp=1733142304~hmac=ba6f32ac1ed76a5c20f14f1318a455fe60e72b387eb013c3269aa174fa29ff16&w=360' alt='' className='img-fluid' />
                                    </div>
                                    <div className=' Home_well_likedcourse_section_content1'>
                                        <a href='#'>NARESH</a>

                                        <div className='Home_well_likedcourse_section_review'>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <span>5 (867)</span>
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <h3>Node.js</h3>
                                    <p className='text-justify'>Node.js is a powerful JavaScript runtime that enables server-side development with high scalability and efficiency. It uses an event-driven, non-blocking architecture, making it ideal for real-time applications and APIs.</p>
                                </div>
                                <hr />
                                <div className='Home_well_likedcourse_section_time'>
                                    <div className='Home_well_likedcourse_section_pp'>
                                        <p> <i class="ri-user-line"></i> 5,650</p>
                                        {/* <p><i class="ri-time-line"></i> 16 : 00</p> */}
                                    </div>

                                    <div className='Home_well_likedcourse_section_time_btn'>
                                        <Link to="/contact-us"> <button>Enroll Now</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4 mt-3' data-aos="fade-up" data-aos-duration="2000">
                        <div className="card">
                            <div className='Home_well_likedcourse_section_img'>
                                <img src={awsimg} className='img-fluid' alt='' />
                            </div>
                            {/* <div className='Home_well_likedcourse_section_cost'>
                                <p>Course Fee : ₹{1500} (USD $
                                    {(1500 * (1 / 80)).toFixed(2)})</p>
                            </div> */}
                            <hr />
                            <div className='Home_well_likedcourse_section_content'>

                                <div className='d-flex'>
                                    <div className=' Home_well_likedcourse_section_content2'>
                                        <img src='https://img.freepik.com/free-vector/woman-floral-traditional-costume_1308-176159.jpg?t=st=1733138742~exp=1733142342~hmac=5ea617218f1677e5bced6fc4aff0c26506f2ea46b7c151c51c42ddd88cefe725&w=360' alt='' className='img-fluid' />
                                    </div>
                                    <div className=' Home_well_likedcourse_section_content1'>
                                        <a href='#'>APOORVA</a>

                                        <div className='Home_well_likedcourse_section_review'>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-fill"></i>
                                            <i class="ri-star-half-line"></i>
                                            <span>4.5 (1,890)</span>
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <h3>Amazon Web Services</h3>
                                    <p className='text-justify'>Amazon Web Services (AWS) is a leading cloud computing platform offering scalable and secure infrastructure solutions. It provides a wide range of services, including computing, storage, and databases, to support various applications.</p>
                                </div>
                                <hr />
                                <div className='Home_well_likedcourse_section_time'>
                                    <div className='Home_well_likedcourse_section_pp'>
                                        <p> <i class="ri-user-line"></i> 4,540</p>
                                        {/* <p><i class="ri-time-line"></i> 16 : 00</p> */}
                                    </div>

                                    <div className='Home_well_likedcourse_section_time_btn'>
                                        <Link to="/contact-us"> <button>Enroll Now</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className='Home_well_likedcourse_section_morebtn'>
                    <button>
                        Read More
                    </button>
                </div> */}
            </div>
        </div>
    )
}

export default HomeWellLikedCourse
